import { Injectable, OnInit } from "@angular/core";
import { ApplicationHttpService } from "../../core/services/application-http.service";
import { catchError, forkJoin, map, Observable, of, Subject, tap } from "rxjs";
import { Country } from "../../features/application/models/address/country.model";
import { BusinessActivity, BusinessActivityCode } from "../models/nature-of-business.model";

const URL = "api/v1/";

@Injectable()
export class SharedService {

    codes: BusinessActivityCode[] = [];
    countries: Country[] = [];

    constructor(private http: ApplicationHttpService) {
    }

    
    
    public getActivityCodes(): Observable<BusinessActivityCode[]> {
        if (this.codes?.length) {
            return of(this.codes);
        }

        return this.loadActivityCodes().pipe(
            tap((codes) => {
                this.codes = codes ?? [];
            }),
            catchError((error) => {
                console.error('Error fetching versions:', error);
                this.codes = [];
                return of([]);
            })
        );
    }
    public getCountryList(): Observable<Country[]> {
        if (this.countries?.length) {
            return of(this.countries);
        }

        return this.loadCountryList().pipe(
            tap((countries) => {
                this.countries = countries ?? [];
            }),
            catchError((error) => {
                console.error('Error fetching versions:', error);
                this.countries = [];
                return of([]);
            })
        );
    }

    public init(): Observable<boolean> {
        return forkJoin([
            this.getActivityCodes(),
            this.getCountryList()
        ]).pipe(
            map(() => true),
                catchError((error) => {
                console.error('Error during init:', error);
                return of(false);
            })
        );
    }

    public getCountryNameById(id: number): string {
        return this.countries.find(i => i.id == id)?.name || '';
    }


    private loadActivityCodes(): Observable<BusinessActivityCode[]> { 
        return this.http.get<BusinessActivityCode[]>(`business-activity/codes/all`);
    }

    private getBusinessActivitiesList(): Observable<BusinessActivity[]> {
        return this.http.get<BusinessActivity[]>(`business-activity/all`);
    }

    private loadCountryList(): Observable<Country[]> {
        return this.http.get<Country[]>(`country`);
    }

}